import { isMobile } from "@/modules/common";
import { ReturnedValue, useSound } from "@vueuse/sound";
import { ref, Ref, watch } from "vue";

const startPlaySound = (param: ReturnedValue) => {
  try {
    param.sound.value?.play();
  } catch {
    // ignore
  }
};

const stopPlaySound = (param: ReturnedValue) => {
  try {
    param.sound.value?.stop();
  } catch {
    // ignore
  }
};

export const useCharacterAudio = (audioUrl: Ref<string>) => {
  const audioSound = useSound(audioUrl, {
    interrupt: true,
  });
  const { sound } = audioSound;
  // 声音切换时，停止播放前一个
  watch(sound, (_, oldSound) => {
    if (oldSound) {
      stopPlaySound({
        ...audioSound,
        sound: ref(oldSound),
      });
    }
    startPlaySound(audioSound);
  });

  return {
    play: () => startPlaySound(audioSound),
    stop: () => stopPlaySound(audioSound),
  };
};

export const useBGM = (bgmUrl: Ref<string>) => {
  const bgmSound = useSound(bgmUrl, {
    interrupt: false,
    loop: true,
    autoplay: false,
    volume: 0.2,
  });

  const play = () => {
    startPlaySound(bgmSound);
  };
  const stop = () => {
    stopPlaySound(bgmSound);
  };
  return {
    play,
    stop,
  };
};

export const useTextBlip = (isDialoguePlaying: Ref<boolean>) => {
  const { play, stop } = useSound("/game/sfx/medium-text-blip.mp3", {
    volume: isMobile() ? 1 : 0.2,
    autoplay: false,
    loop: true,
  });

  watch(
    isDialoguePlaying,
    (newIsDialoguePlaying) => {
      if (newIsDialoguePlaying) {
        play();
      } else {
        stop();
      }
    },
    { immediate: true }
  );

  return {
    play,
    stop,
  };
};
